export function mapActivityFromDto(dto) {
    return {
        ...dto,
        createdAt: new Date(dto.createdAt),
    };
}
